<ng-container *ngFor="let inputAttr of orderedInputAttributes$$ | async">
  <ng-container *ngIf="hasControl(inputAttr.name)" [ngSwitch]="inputAttr.valueType">
    <forms-boolean-attribute
      *ngSwitchCase="1"
      [controlID]="inputAttr.name"
      [displayName]="inputAttr.displayName"
      [control]="getControl(inputAttr.name)"
      (cleared)="clearAttribute($event)"
    ></forms-boolean-attribute>
    <forms-single-enum-attribute
      *ngSwitchCase="2"
      [controlID]="inputAttr.name"
      [displayName]="inputAttr.displayName"
      [selectOptions]="inputAttr.valueDisplayNames"
      [control]="getControl(inputAttr.name)"
      (cleared)="clearAttribute($event)"
    ></forms-single-enum-attribute>
    <forms-url-attribute
      *ngSwitchCase="3"
      [controlID]="inputAttr.name"
      [displayName]="inputAttr.displayName"
      [control]="getControl(inputAttr.name)"
      (cleared)="clearAttribute($event)"
    ></forms-url-attribute>
    <forms-repeated-enum-attribute
      *ngSwitchCase="4"
      [controlID]="inputAttr.name"
      [displayName]="inputAttr.displayName"
      [checkboxOptions]="inputAttr.valueDisplayNames"
      [formGroup]="getFormGroup(inputAttr.name)"
      (cleared)="clearAttribute($event)"
    ></forms-repeated-enum-attribute>
    <forms-text-attribute
      *ngSwitchDefault
      [controlID]="inputAttr.name"
      [displayName]="inputAttr.displayName"
      [control]="getControl(inputAttr.name)"
      (cleared)="clearAttribute($event)"
    ></forms-text-attribute>
  </ng-container>
</ng-container>
